import { input, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Color } from './types';

@Component({
  selector: 'app-chip, span[appChip], div[appChip]',
  standalone: true,
  exportAs: 'app-chip',
  templateUrl: './chip.html',
  styleUrl: './chip.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'chip',
    '[class]': '[color()]',
  },
})
export class Chip {
  public color = input<Color>('default');
}
